import React from "react";

const Header: React.FC = () => {
  return (
    <header className="minimal-header">
      <h1>Ștefan Lică</h1>
      <p className="subtitle">Full Stack Software Engineer</p>
    </header>
  );
};

export default Header;
